import { Grid, makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { StepTitle } from '../common/stepTitle';
import { EconomicsCard } from './economicsCard';
import { LoanDetailsCardProps } from './summaryStep';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  ivQuestionContainer: {
    border: '1px solid #326bbd',
    backgroundColor: '#f0f9ff',
    minWidth: '100%',
    borderRadius: '10px',
  },
  button: {
    marginTop: '25px',
    marginBottom: '25px',
    width: '200px',
  },
  text: {
    marginTop: '10px',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

interface EconomicsStepProps {
  store: IQuoteTypeStore;
  LoanDetailsCard: React.FC<LoanDetailsCardProps>;
}

export const EconomicsStep = observer(
  ({ store, LoanDetailsCard }: EconomicsStepProps) => {
    const { loanEconomicsStore } = store;

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StepTitle title={<>Loan Economics</>} />
          </Grid>
          <Grid item xs={12}>
            <LoanDetailsCard store={store} />
          </Grid>
          <Grid item xs={12}>
            <EconomicsCard store={store} />
          </Grid>
        </Grid>
      </>
    );
  }
);
